import { useQuery } from "@tanstack/react-query";
import { getClients } from "api/client.api";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

export const useGetClients = () => {
  return useQuery({
    queryKey: QUERY_KEYS.clients.list(),
    queryFn: () => getClients({ page: 1, limit: 50 }),
    select: (data) => data?.clients ?? [],
    staleTime: DEFAULT_STALE_TIME,
  });
};
